import { createRequiredContext } from 'src/context/createRequiredContext';

import { useIntegrationSlice } from './useIntegrationSlice';

const [useIntegration, IntegrationProvider] = createRequiredContext<ReturnType<typeof useIntegrationSlice>>();

const IntegrationContextProvider = ({ children }: React.PropsWithChildren) => {
  const integrationSlice = useIntegrationSlice();
  const values = {
    ...integrationSlice,
  };

  return <IntegrationProvider value={values}>{children}</IntegrationProvider>;
};

export { IntegrationContextProvider, useIntegration };
